'use client';

import { AppUpsellSlide } from '@/components/app-upsells/app-upsell-slide';

export function LandingAppUpsell(): React.ReactNode {
  return (
    <div
      className="app-upsell-landing mx-auto h-48 w-full max-w-4xl overflow-hidden rounded-card sm:h-56 lg:h-64"
      data-testid="landing-app-upsell"
    >
      <AppUpsellSlide entryPoint="landing" />
    </div>
  );
}
